module.exports = __webpack_public_path__ + "static/media/023.c1340cc5.jpg";